import { trackElementViewed } from '@/features/shared/analytics/element'

// As we are debugging the behavior of the view tracker
// We want to ensure that users are actually seeing things once
// Before we proceed with any code updates to make a data driven decision
// All functions below will be temporary until we are sure of results

export const trackViewedTracker = ({
  elementName,
  canShowPopupModal,
  isSetOnly,
}: {
  elementName: string
  canShowPopupModal: boolean
  isSetOnly?: boolean
}) => {
  trackElementViewed({
    content: 'view_tracker_debug',
    message_goal: isSetOnly ? 'firing seen only' : 'seeing and firing',
    type: `${elementName} is viwable: ${canShowPopupModal}`,
  })
}

export const trackViewedTrackerIncremented = ({
  elementName,
  canShowPopupModal,
}: {
  elementName: string
  canShowPopupModal: boolean
}) => {
  trackElementViewed({
    content: 'view_tracker_debug',
    message_goal: 'incremented',
    type: `${elementName} is viwable: ${canShowPopupModal}`,
  })
}
